<template>
  <el-dialog
    v-if="visibles"
    :visible.sync="visibles"
    :before-close="closeDialog"
    :close-on-click-modal="false"
    :lock-scroll="false"
    :destroy-on-close="true"
    top="8vh"
    :show-close="false"
    center
  >
    <dialog-header
      slot="title"
      :icon="'icon-charge-detail'"
      :title="$t('diagnostics.faultcodemanage.faultcode.detailFaulcode')"
      @close="closeDialog"
    />
    <vue-linetitle>
      <el-form
        ref="formLeft"
        :model="formInfo"
        :label-position="'right'"
        :label-width="$t('diagnostics.faultcodemanage.faultcode.addUpdateDialog.labelWidth.formLeft')"
      >
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$t('diagnostics.faultcodemanage.faultcode.addUpdateDialog.faultcode')+'：'">
              {{ formInfo.faultCode }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('diagnostics.faultcodemanage.faultcode.addUpdateDialog.ispopfault')+'：'" :label-width="$t('diagnostics.faultcodemanage.faultcode.addUpdateDialog.labelWidth.formRight')">
              {{ formInfo.isPush | isPopFaultText(formInfo.isPush) }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$t('diagnostics.faultcodemanage.faultcode.brand')+'：'">
              {{ formInfo.specificBrand }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item :label="$t('diagnostics.faultcodemanage.faultcode.addUpdateDialog.faultname')+'：'">
              {{ formInfo.faultName }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item :label="$t('diagnostics.faultcodemanage.faultcode.detailFaulcode')+'：'">
              <div v-if="formInfo.faultContent.length > 500" style="min-height:15px;height:160px;word-wrap:break-word;word-break:normal;">
                <el-scrollbar style="height:100%" wrap-class="default-scrollbar__wrap">
                  <div>{{ formInfo.faultContent }}</div>
                </el-scrollbar>
              </div>
              <span v-else>{{ formInfo.faultContent }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item :label="$t('public.note')+'：'">
              {{ formInfo.remark }}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </vue-linetitle>
  </el-dialog>
</template>

<script>
// 混入
import { partialForm } from '@/mixins/partialForm'

export default {
  name: 'DetailDialog',
  filters: {
    faultLevelText(val) {
      return val === 1 ? vm.$t('diagnostics.faultcodemanage.faultcode.level1') : val === 2 ? vm.$t('diagnostics.faultcodemanage.faultcode.level2') : val === 3 ? vm.$t('diagnostics.faultcodemanage.faultcode.level3') : val === 4 ? vm.$t('diagnostics.faultcodemanage.faultcode.level4') : ''
    },
    isPopFaultText(val) {
      return val === 0 ? vm.$t('diagnostics.faultcodemanage.faultcode.no') : val === 1 ? vm.$t('diagnostics.faultcodemanage.faultcode.yes') : ''
    }
  },
  mixins: [partialForm],
  props: {
    visibles: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      formInfo: {},
      carPartList: []
    }
  },
  watch: {
    visibles(e1) {
      if (e1) {
        this.formInfo = { ...this.data }
      }
    }
  },
  created() {
  },
  methods: {
    // 关闭
    closeDialog() {
      this.$emit('update:visibles', false)
    },
    // 取消
    handleCancel() {
      this.closeDialog()
    }
  }
}
</script>

<style scoped>

</style>
